/**
 * @Description 忘记密码弹窗
 */
import V2Form from '@/common/components/Form/V2Form';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import GetCode from '@/common/components/business/GetCode';
import { Form, Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import { MOBILE_REG } from '@lhb/regexp';
import V2FormInputPassword from '@/common/components/Form/V2FormInputPassword/V2FormInputPassword';
import { handleLogout, resetPassword } from '@/common/api/user';
import { logout } from '@/common/utils/ways';
// 8~16位数字或密码组合的密码
const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{8,16}$/;
const ResetPasswordModal:FC<any> = ({
  visible,
  setVisible
}) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const handleOk = () => {
    form.validateFields().then((res) => {
      if (!passwordRegex.test(res.password)) {
        V2Message.error('请输入8-16位数字或字母组合的密码');
        return;
      }
      if (res.password !== res.rePassword) {
        V2Message.error('两次输入的密码不一致');
        return;
      }
      setConfirmLoading(true);

      // 如果服务端抛错，不关闭弹窗，但是要关闭setConfirmLoading
      resetPassword(res)
        .then(() => {
          V2Message.success(`密码修改成功`);
          setVisible(false);
          handleLogout();
          logout();
        })
        .finally(() => {
          setConfirmLoading(false);
        });
    });

  };
  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    visible && form.resetFields();
  }, [visible]);

  return <Modal
    title='重置密码'
    open={visible}
    okText='重置'
    onOk={handleOk}
    onCancel={handleCancel}
    confirmLoading={confirmLoading}
    centered
  >
    <V2Form
      form={form}
    >
      <V2FormInput
        label='手机号'
        name='mobile'
        rules={[
          { required: true, message: '请输入手机号' },
          { pattern: MOBILE_REG, message: '手机号格式错误' },
        ]}
        maxLength={11}
        config={{ autoComplete: 'on' }}
      />
      <V2FormInput
        name='code'
        label='短信验证码'
        rules={[{ required: true, message: '请输入验证码' }]}
        maxLength={6}
        config={{
          suffix: <GetCode form={form} className={styles.inputStyle} />,
        }}
      />
      <V2FormInputPassword
        label='新密码'
        required
        name='password'
        placeholder='设置8-16位数字或字母组合的密码'
        config={{
          autoComplete: 'new-password'
        }}
      />
      <V2FormInputPassword
        label='确认密码'
        required
        name='rePassword'
        placeholder='请再次输入新密码'
      />
    </V2Form>
  </Modal>;
};
export default ResetPasswordModal;
